
import Vue from "vue";
import AppAdminSelect from "../components/AdminSelect.vue";
import AppClientSearch from "../components/ClientSearch.vue";
import AppDepartmentSelect from "../components/DepartmentSelect.vue";
import AppDossierSelect from "../components/DossierSelect.vue";
import {Admin} from "@/models/admin";
import {User} from "@/models/user";
import {INewTicketData, TicketService} from "@/services/ticket-service";
import {CompanyService} from "@/services/company-service";
import {Company} from "@/models/company";
import { CompanyUserService } from "@/services/company-user-service";
import {AdminsService} from "@/services";

export default Vue.extend({
	data() {
		return {
			client: null as User | null,
			admins: [] as Admin[],
			attentions: [] as Admin[],
			sheduleTicket: false,
			date: new Date(),
			time: new Date(),
			ticketData: {
				dossierId: 0,
				clientId: 0,
				departmentId: 3,
				adminIds: [],
				attentionAdminIds: [],
				internal: true,
				message: "",
				subject: "",
				timeSheduled: new Date(0)
			} as INewTicketData
		};
	},
	watch: {
		client(){
			this.ticketData.dossierId = this.client?.company.dossiers[0].id || 0;
		}
	},
	methods: {
		async submit() {
			if (!this.ticketData.subject || !this.ticketData.message || this.client == null) {
				this.$wf.notify("Gelieve een onderwerp of boodschap in te geven", "danger", 3000, "info");
				return;
			}
			await this.autoAttention();
			this.ticketData.adminIds = this.admins.map(a => a.id);
			this.ticketData.attentionAdminIds = this.attentions.map(a => a.id);
			this.ticketData.clientId = this.client.id;
			if (this.sheduleTicket) {
				this.ticketData.timeSheduled = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(),
					this.time.getHours(), this.time.getMinutes(), this.time.getSeconds());
			}
			let ticket = await TicketService.createTicket(this.ticketData);
			this.$router.push(`/ticket/${ticket.id}`);
		},
		async autoAttention() {
			let a = await AdminsService.getAdmins();
			a.forEach((a) => {
				if(a.firstName.toLowerCase()=="winfakt"){
					return;
				}
				if (this.ticketData.message.toLowerCase().indexOf("@" + a.firstName.toLowerCase()) > -1) {
					this.attentions.push(new Admin(a));
				}
				if (this.ticketData.message.toLowerCase().indexOf("@sales") > -1) {
					if ([49, 55, 101, 118].includes(a.id)) {
						this.attentions.push(new Admin(a));
					}
				}
				if (this.ticketData.message.toLowerCase().indexOf("@kd") > -1) {
					if ([45, 57].includes(a.id)) {
						console.log(a);
						this.attentions.push(new Admin(a));
					}
				}
			});
		},
	},
	async mounted(){
		if (this.$route.query.userId && this.$route.query.companyId) {
			let user = await CompanyUserService.getUser(parseInt(this.$route.query.companyId as string), parseInt(this.$route.query.userId as string));
			this.client = user;
		} else if (this.$route.query.companyId) {
			let company = await CompanyService.getCompany(parseInt(this.$route.query.companyId as string)) as Company;
			this.client = company.users[0];
		}
	},
	components: {
		AppClientSearch,
		AppDepartmentSelect,
		AppDossierSelect,
		AppAdminSelect
	}
});
